import { createContext, useContext } from 'react';

import { WellPadPreparationStore } from './well-pad-preparation.store';

export const WellPadPreparationStoreContext = createContext<{
  wellPadPreparationStore: WellPadPreparationStore | null;
}>({
  wellPadPreparationStore: null,
});

export const usePadPreparationStore = () => {
  const { wellPadPreparationStore } = useContext(WellPadPreparationStoreContext);

  if (!wellPadPreparationStore) {
    throw new Error('wellPadPreparationStore is not initiated');
  }

  return wellPadPreparationStore;
};
